import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BlockCauseService } from 'modules/crm/settings/block-cause/services';
import { BLOCK_CAUSES_LIST_KEY } from 'modules/crm/settings/block-cause/constants';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useDeleteBlockCause = (id: string, onClose: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('blockCause');
  return useMutation(() => BlockCauseService.delete(id), {
    onSuccess: (data) => {
      toast.success(t('successDeleted'));
      onClose?.();
      queryClient.invalidateQueries({ queryKey: [BLOCK_CAUSES_LIST_KEY] });
      queryClient.invalidateQueries({ queryKey: [id] });
    },
  });
};
